/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCostChangesQueries } from '../../models/get-cost-changes-queries';
import { GetCostChangesQueriesResult } from '../../models/get-cost-changes-queries-result';

export interface ApiProjectCostChangeGetAllProjectCostChangesPost$Plain$Params {
  
    /**
     * [Id for project]
     */
    body?: GetCostChangesQueries
}

export function apiProjectCostChangeGetAllProjectCostChangesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCostChangeGetAllProjectCostChangesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCostChangesQueriesResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCostChangeGetAllProjectCostChangesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCostChangesQueriesResult>;
    })
  );
}

apiProjectCostChangeGetAllProjectCostChangesPost$Plain.PATH = '/api/ProjectCostChange/GetAllProjectCostChanges';
